import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import ServiceItem from './ServiceItem';
import s from './Services.style';

class Services extends Component {
  state = {};

  render() {
    return (
      <div className={css(s.servicesWrapper)}>
        <h2 className={css(s.servicesTitle)}>Szolgáltatásaim</h2>
        <div className={css(s.serviceWrapperInner)}>
          <ServiceItem
            image={'images/services/alkalmi-smink.jpg'}
            title={'Alkalmi smink'}
            lead={'Hivatalos eseményre, buliba'}
            description={
              <React.Fragment>
                <p>
                  Fontos eseményre készülsz Budapesten? Esküvőre, szalagavatóra, fotózásra vagy buliba hívnak? Ilyenkor
                  jól jön egy profi alkalmi smink, ami egész nap tart, mégis természetes marad.
                </p>
                <p>Alkalmi smink kategóriába tartozik:</p>
                <ul>
                  <li>Nappali smink</li>
                  <li>Esti smink</li>
                  <li>Szalagavató smink</li>
                  <li>Smink fotózásra kiszállás nélkül</li>
                  <li>Smink fitness versenyre kiszállás nélkül</li>
                </ul>
                <p>A műszempilla felhelyezése feláras!</p>
              </React.Fragment>
            }
            time={'1 óra'}
            price={'20 000 Ft'}
          />
          <ServiceItem
            image={'images/services/eskuvo.jpg'}
            title={'Esküvői smink csomag'}
            lead={'Konzultáció, próbasmink'}
            description={
              <React.Fragment>
                <ul>
                  <li>Részletes konzultáció</li>
                  <li>Próbasminket, ami garanciális</li>
                  <li>Sminked az esküvő napján</li>
                  <li>Vőlegény arcának lemattítását</li>
                </ul>
                <p>További feláras szolgáltatások:</p>
                <ul>
                  <li>Vendégek sminkje - 15 000 Ft/fő</li>
                  <li>Műszempilla felhelyezés - 3-8 000 Ft/fő</li>
                  <li>Smink kreatív fotózásra - 20 000 Ft</li>
                  <li>Készenléti felár fotózásra - 5 000 Ft/óra</li>
                  <li>Budapest területén kiszállás - 5 000 Ft (2 extra smink igény esetén ingyenes)</li>
                  <li>
                    Vidéki kiszállás csak abban az esetben lehetséges, ha minimum 4 extra sminkre van igény, és ebben az
                    esetben 100 Ft/km a kiszállás díja.
                  </li>
                </ul>
              </React.Fragment>
            }
            time={'1,5-3 óra '}
            price={'60 000 Ft'}
          />
          <ServiceItem
            image={'images/services/sminktanacsadas.jpg'}
            title={'Egyéni sminktanácsadás és oktatás'}
            lead={'Személyre szabva, tippek és trükkök'}
            description={
              <React.Fragment>
                <p>
                  Szeretnél megtanulni, hogyan sminkelj magad gyorsan, természetesen és profin? Akkor nem
                  YouTube-trükköket kell bemagolnod, hanem végre érteni, hogy mi miért és hogyan működik a saját
                  arcodon.
                </p>
                <p>
                  Nem én mondom meg, hogy mit fogsz tanulni, Te mondod meg nekem, hogy mit szeretnél elsajátítani. Az
                  oktatás végén részletes összefoglalót kapsz a tanultakról, minden apró trükkről.
                </p>
                <p>
                  Ha szeretnél jobban, gyorsabban, tudatosabban sminkelni, ha szeretnél olyan trükköket eltanulni,
                  amivel megkönnyíted a reggeli készülődést, vagy ha szeretnél kicsit jobban odafigyelni az arcápolási
                  rutinodra, akkor az <b>Egyéni sminktanácsadás</b> Neked való.
                </p>
                <p>További részletekért keress privát üzenetben.</p>
              </React.Fragment>
            }
            time={'3-4 óra'}
            price={'45 000 Ft'}
          />
          <ServiceItem
            image={'images/services/muszempilla.jpg'}
            title={'Műszempilla felhelyezés'}
            lead={'Minőségi, természetes'}
            description={
              <React.Fragment>
                <p>Kizárólag minőségi, természetes, kényelmes szempillákat használok.</p>
                <p>A pilla dobozát minden esetben odaadom, így többször is fel lehet használni őket.</p>
              </React.Fragment>
            }
            time={'15 perc '}
            price={'3 000 - 8 000 Ft'}
          />

          <ServiceItem
            image={'images/services/ajandekutalvany.jpg'}
            title={'Ajándékutalvány'}
            lead={'Ajándékozz élményt'}
            description={
              <React.Fragment>
                <p>Minden szolgáltatás megvásárolható ízléses, névre szóló ajándékutalvány formájában.</p>
                <p>A legjobb döntés élményt ajándékozni valakinek, nem egy újabb porfogót a polcra.</p>
              </React.Fragment>
            }
            time={''}
            price={''}
          />
        </div>
      </div>
    );
  }
}

export default Services;
